import { useMenuStore } from "../stores";
/**
 * Cek apakah user punya akses ke menu tertentu
 * @param menus state menus dari useMenuStore
 * @param menuId id menu yang ingin dicek
 * @returns boolean
 */
export const hasMenuAccess = (menus, menuId) => {
    if (!menus)
        return false;
    const checkNode = (nodes) => {
        for (const node of nodes) {
            if (node.idMenu === menuId)
                return true;
            if (node.children?.length && checkNode(node.children))
                return true;
        }
        return false;
    };
    return checkNode(menus);
};
/**
 * Hook untuk mendapatkan hak akses CRUD untuk menu tertentu
 * @param menuId id menu yang ingin dicek
 * @returns object berisi canCreate, canRead, canUpdate, canDelete
 */
export const useMenuPermissions = (menuId) => {
    const menus = useMenuStore((state) => state.menus);
    const findNode = (nodes) => {
        if (!nodes)
            return null;
        for (const node of nodes) {
            if (node.idMenu === menuId)
                return node;
            if (node.children?.length) {
                const found = findNode(node.children);
                if (found)
                    return found;
            }
        }
        return null;
    };
    const node = findNode(menus);
    return {
        canCreate: node?.canCreate ?? false,
        canRead: node?.canRead ?? false,
        canUpdate: node?.canUpdate ?? false,
        canDelete: node?.canDelete ?? false,
    };
};
